export default "__VITE_ASSET__OC2w727k__"